import React from 'react';
import SettingGroupsPanel from './SettingGroupsPanel';

export default function SettingsDataPage() {
  return (
    <SettingGroupsPanel />
  );
}
